<div class="col indication-definition-mobile-border indication-definition-web-border">
  <!-- <h6 style="color: white;">Definition</h6> -->
  <div class="indication-definition-overflow-container">
    <p class="indication-definition">{{definition}}</p>
  </div>
</div>